import useScrollRestoration from 'Features/hooks/useScrollRestoration';
import React, { ReactNode } from 'react';

const ScrollRestorationWrapper = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => {
  useScrollRestoration();
  return <>{children}</>;
};

export default ScrollRestorationWrapper;
